import React, { useEffect } from 'react';
import { FaBars, FaInstagram } from 'react-icons/fa';
import { animateScroll as scroll } from 'react-scroll';
import {
  Nav,
  NavBarContainer,
  NavLogo,
  MobileIcon,
  NavMenu,
  NavLinks,
  NavItem,
  NavBtn,
  NavBtnLink,
  NavBarImg,
  NavBarIntro,
  NavBarCity,
  Info,
  InfoPhone,
  InfoP,
  InfoIcon,
  NavBarWrapper,
  SocialMediaWrapper,
  SocialMediaLink,
  RightBlock,
  InfoPhoneMobile,
} from './NavBar';
import Img1 from '../../images/logo.png';
import { PhoneIcon } from '../Icons';

const NavBar = ({ toggle }) => {
  const toggleHome = () => {
    scroll.scrollToTop();
  };

  // console.log(window.innerWidth);
  let setOffset = 0;
  useEffect(() => {
    const getSize = window.innerWidth;
    setOffset = getSize < 401 ? '-80' : '-160';
  }, []);

  return (
    <>
      <Nav>
        <NavBarContainer>
          <NavBarIntro>
            <NavBarImg src={Img1}></NavBarImg>
            <NavLogo to="/" onClick={toggleHome}>
              МЭТР
            </NavLogo>
            <NavBarCity>Краснодар</NavBarCity>
            <InfoPhoneMobile>
              <InfoP>тел: +7(988) 240-52-88</InfoP>
              <InfoP>+7(906) 435-23-30</InfoP>
            </InfoPhoneMobile>
          </NavBarIntro>

          <RightBlock>
            <Info>
              <InfoP style={{ textAlign: 'end' }}>ooo.metr@mail.ru</InfoP>
              <InfoPhone>
                <InfoP>тел: +7(988) 240-52-88</InfoP>
                <InfoP>+7(906) 435-23-30</InfoP>
              </InfoPhone>
              <InfoIcon>{PhoneIcon}</InfoIcon>
              {/* <p>картинка</p> */}
            </Info>

            <NavBarWrapper>
              <MobileIcon onClick={toggle}>
                <FaBars />
              </MobileIcon>
              <NavMenu>
                <NavItem>
                  <NavLinks
                    to="main"
                    smooth={true}
                    duration={500}
                    spy={true}
                    exact="true"
                    offset={-160}
                    activeClass="active"
                  >
                    Главная
                  </NavLinks>
                </NavItem>
                <NavItem>
                  <NavLinks
                    to="work"
                    smooth={true}
                    duration={500}
                    spy={true}
                    exact="true"
                    offset={-160}
                    activeClass="active"
                  >
                    Услуги
                  </NavLinks>
                </NavItem>
                <NavItem>
                  <NavLinks
                    to="gallery"
                    smooth={true}
                    duration={500}
                    spy={true}
                    exact="true"
                    offset={-160}
                    activeClass="active"
                  >
                    Наши работы
                  </NavLinks>
                </NavItem>
                <NavItem>
                  <NavLinks
                    to="about"
                    smooth={true}
                    duration={500}
                    spy={true}
                    exact="true"
                    offset={-160}
                    activeClass="active"
                  >
                    О нас
                  </NavLinks>
                </NavItem>
              </NavMenu>
              <NavBtn>
                {/* <NavBtnLink to="/calculate">Калькулятор</NavBtnLink> */}
                <NavBtnLink>Калькулятор</NavBtnLink>
              </NavBtn>

              <SocialMediaWrapper>
                {/* https://instagram.com/ooo.metr?igshid=24b8ow6kabnp */}
                <SocialMediaLink
                  href="//www.instagram.com/ooo.metr"
                  target="_blank"
                  area-label="Instagram"
                >
                  <FaInstagram />
                </SocialMediaLink>
              </SocialMediaWrapper>
            </NavBarWrapper>
          </RightBlock>
        </NavBarContainer>
      </Nav>
    </>
  );
};

export default NavBar;
